module.exports = __webpack_public_path__ + "static/img/3.5149de0.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/3.gif
// module id = 05ir
// module chunks = 1